import { Spinner } from 'components/ui';
import React, { useCallback, useEffect, useState, lazy, Suspense } from 'react';
import { UPLOAD_STATUS } from './constants';
import { bytesToSize, fileInformationRequest } from './helpers';

const SeismicUniversalUploader = lazy(() =>
  import(/* webpackChunkName: "UUC" */ './Uploader'),
);

const Loader = () => (
  <div className="mt-16 ta-c">
    <Spinner size="larger" />
  </div>
);

// temporarily used to lo lazy load the uploader component since there's an outstanding issue lazy loading @seismic/universal-upload-component directly
const UniversalUploader = ({
  uploaderId,
  accept,
  onComplete,
  onFileError,
  onDelete,
  readOnly,
}) => {
  const [loading, setLoading] = useState(uploaderId !== null);
  const [uploaderFileName, setFileName] = useState('');
  const [uploaderFileSize, setFileSize] = useState(0);
  const [uploaderFileUrl, setFileUrl] = useState(null);
  const [uploaderStatus, setUploaderStatus] = useState(UPLOAD_STATUS.INITIAL);

  const getFileDetails = useCallback(async () => {
    if (!uploaderId) return;
    try {
      const { url, name, size } = await fileInformationRequest(uploaderId);
      if (!name || !size) throw new Error('File name or size not found');
      setFileName(name);
      setFileSize(bytesToSize(size));
      if (!url) throw new Error('File url not found');
      setFileUrl(url);
      setUploaderStatus(UPLOAD_STATUS.COMPLETE);
    } catch (e) {
      console.error(e);
      setUploaderStatus(UPLOAD_STATUS.ERROR);
    } finally {
      setLoading(false);
    }
  }, [uploaderId]);

  useEffect(() => {
    getFileDetails();
  }, [getFileDetails]);

  if (loading) {
    return <Loader />;
  }

  return (
    <Suspense fallback={<Loader />}>
      <SeismicUniversalUploader
        uploaderFileName={uploaderFileName}
        uploaderFileSize={uploaderFileSize}
        uploaderFileUrl={uploaderFileUrl}
        uploaderFileId={uploaderId}
        uploaderStatus={uploaderStatus}
        accept={accept}
        onComplete={onComplete}
        onDelete={onDelete}
        onFileError={onFileError}
        readOnly={readOnly}
      />
    </Suspense>
  );
};

export { UniversalUploader };
